export type ApiError = {
  response: { data: { message: string } };
};

export enum Status {
  active = 'active',
  inactive = 'inactive',
  both = 'both',
}

export type NewBoxSection = {
  section: string;
  forms: {
    label: string;
    url?: string;
    access?: string;
  }[];
  access?: string[];
};
